import { Router, ActivatedRoute, Params } from '@angular/router';
import { RoomsService } from './../shared/services/rooms.service';
import { LangCodes } from './../shared/enums/lang-codes.enum';
import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { Room } from '../shared/models/rooms.model';
import { RoomDetailService } from '../shared/services/room-detail.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  langSelected: string;
  showTranslateButton: boolean = false;
  room: Room;
  sidebarCollapsed: boolean = true;
  isLandingPage: boolean;

  constructor(
    private translate: TranslateService,
    private roomsService: RoomsService,
    ) { }

  ngOnInit() { 
    this.langSelected = localStorage.getItem("langSelected");
    this.isLandingPage = window.scrollY < window.innerHeight;
  }
  
  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.isLandingPage = window.scrollY < window.innerHeight;
  }

  switchLanguage(lang:string) {
    this.showTranslateButton = false;
    this.langSelected = lang;
    this.translate.use(this.langSelected);
    localStorage.setItem("langSelected", this.langSelected);
    this.roomsService.getRooms(this.langSelected).subscribe((rooms: any) => {
      sessionStorage.setItem('roomsData', JSON.stringify(rooms));
    });
  }

  scrollToSection($event){
    this.sidebarCollapsed = !this.sidebarCollapsed
    var section = document.getElementById($event.target.attributes.name.value);
    section.scrollIntoView({block: "start", behavior: "smooth"});
  }

}
